import Parse from 'parse';

export enum FeatureFlagFields {
  TABLE = "FeatureFlag",
  ENTITY = "entity",
  ENTITY_ID = "entityId",
  FEATURE = "feature",
  ENABLED = "enabled",
}

export type Entity = "MethodType" | "CaseType" | "Pipeline";
export type Feature = "morfogen";

export class FeatureFlag extends Parse.Object {
  static className = FeatureFlagFields.TABLE;

  constructor() {
    super(FeatureFlag.className);
  }

  get entity(): Entity {
    return this.get(FeatureFlagFields.ENTITY);
  }

  set entity(value: Entity) {
    this.set(FeatureFlagFields.ENTITY, value);
  }

  get entityId(): string {
    return this.get(FeatureFlagFields.ENTITY_ID);
  }

  set entityId(value: string) {
    this.set(FeatureFlagFields.ENTITY_ID, value);
  }

  get feature(): string {
    return this.get(FeatureFlagFields.FEATURE);
  }
  set feature(value: string) {
    this.set(FeatureFlagFields.FEATURE, value);
  }

  get enabled(): boolean {
    return this.get(FeatureFlagFields.ENABLED);
  }
  set enabled(value: boolean) {
    this.set(FeatureFlagFields.ENABLED, value);
  }
}
